import { mapGetters } from 'vuex'

export default function useABTesting (campaignName = 'default') {
  const mixin = {
    props: {
      useCampaign: {
        type: String,
        default: null
      }
    },
    computed: {
      ...mapGetters('abTesting', ['getCampaignConfig']),
      campaign: function () {
        // Workaround for enabling AB-Test-Modules where the campaign is defined in contao
        if (campaignName === 'default' && this.useCampaign) {
          return this.useCampaign
        }
        return campaignName
      },
      campaignGroupList: function () {
        const config = this.getCampaignConfig(this.campaign)
        return config?.groups?.map(group => group.name) || []
      }
    },
    methods: {
      isInWebview () {
        return window.App !== undefined && window.App.reset !== undefined && window.App.refreshedToken !== undefined
      },
      isIosApp () {
        return window.webkit?.messageHandlers?.reset?.postMessage || false
      }
    }
  }
  mixin.computed['ab_' + campaignName] = function () {
    // Probing scripts always get default content
    const probingCookie = window.cookieNS.main.getCookie('probing')
    if (probingCookie) {
      return false
    }
    // Try from cookie first
    const cookieKey = 'ab_' + this.campaign
    let simonAppCookie = window.cookieNS.main.getCookie('simonApp')
    // Otherwise determine Group
    const config = this.getCampaignConfig(this.campaign)
    if (config === undefined) {
      return false
    }
    if (simonAppCookie) {
      simonAppCookie = JSON.parse(simonAppCookie)
      if (simonAppCookie[cookieKey] !== undefined) {
        // Update Cookie persistence - lowest of (now+persistence in days) or configured end of campaign
        const persistenceTs = Math.min(Math.round(Date.now() / 1000) + (86400 * config.persistence), config.end)
        window.cookieNS.main.setSimonAppCookie(cookieKey, { group: simonAppCookie[cookieKey].group, valid: persistenceTs })
        return simonAppCookie[cookieKey].group
      }
    }
    // CampaignFilters
    if (config.limit === 'browser' && this.isInWebview()) { // No App User
      return false
    }
    if (config.limit === 'app' && !this.isInWebview()) { // Only App User
      return false
    }
    if (config.limit === 'app-ios' && (!this.isInWebview() || !this.isIosApp())) { // Only IOS-App User
      return false
    }
    if (config.limit === 'app-android' && (!this.isInWebview() || this.isIosApp())) { // Only Android-App User
      return false
    }
    // User is clear to participate in test
    let finalGroup = false
    const rand = Math.random() * config.weightSum
    config.groups.forEach(group => {
      if (finalGroup === false && rand <= group.weightLimit) {
        finalGroup = group.name
      }
    })
    // Write to cookie
    if (finalGroup) {
      // Determine Cookie persistence - lowest of (now+persistence in days) or configured end of campaign
      const persistenceTs = Math.min(Math.round(Date.now() / 1000) + (86400 * config.persistence), config.end)
      window.cookieNS.main.setSimonAppCookie(cookieKey, { group: finalGroup, valid: persistenceTs })
    }
    return finalGroup
  }

  return mixin
}
